module.exports = __webpack_public_path__ + "img/index-section6-friend10_a.4f76b3eb.svg";